export default __webpack_public_path__ + "static/media/cha_medic_mulberry.b7d7df02.png";